import { StarIcon } from '@c/icons';
import CarouselComponent from '@ui/Carousel';

type SellerReviewType = {
  description: string;
  name: string;
};

const ReviewContent = ({ review }: { review: SellerReviewType }) => (
  <div className="flex h-full flex-col justify-evenly">
    <div className="flex justify-center">
      <StarIcon />
      <StarIcon />
      <StarIcon />
      <StarIcon />
      <StarIcon />
    </div>
    <div className="mt-[2.8rem] line-clamp-4 text-center text-[1.6rem] font-normal sm:line-clamp-none">
      {review.description}
    </div>
    <div className="text-center text-[1.6rem] font-semibold">{review.name}</div>
  </div>
);

export const SellerReviewCard = ({ review }: { review: SellerReviewType }) => (
  <div className="flex h-[25.3rem] w-[32rem] shrink-0 flex-col justify-between gap-[2.4rem] bg-[#F6F6F6] p-[2.4rem] shadow-sm md:w-[38.4rem]">
    <ReviewContent review={review} />
  </div>
);

export const Reviews = () => {
  return (
    <div className="no-scrollbar relative mx-auto ml-[-0.2rem] w-[95%] md:ml-0 md:w-full md:px-[5rem] lg:px-[12rem]">
      <CarouselComponent
        items={reviews.map((review, i) => (
          <SellerReviewCard key={i} review={review} />
        ))}
        incrementBy={1}
      />
    </div>
  );
};
export const reviews: SellerReviewType[] = [
  {
    name: 'Rhall54',
    description:
      'MX Locker is my go to place to buy and sell riding gear. Sold my Fox Instincts through the app and the entire process was so easy!',
  },
  {
    name: 'A.Rankin.68',
    description: `This app has allowed me to get out of spam emails and calls, it's allowed me to move my un-used or not being used items. It's also allowed me to build a very competitive motorcycle for racing use with a budget.`,
  },
  {
    name: 'Romerom97',
    description: `Best place to turn old gear and parts into cash. Highly recommend using this site over eBay or any other marketplace. It's built specifically for the dirt bike community!`,
  },
  {
    name: 'ZachE96',
    description:
      'Very simple experience. Most efficient process to sell dirt bike gear and parts, and able to make some extra cash!',
  },
  {
    name: 'Logan',
    description:
      'I have bought and sold a little over $10,000 worth of products through the app so far, and my experience has been phenomenal. Highly recommended for both buyers and sellers of new and pre-owned products!',
  },
];
export const SellerReviews = () => {
  return (
    <div className="mt-[1.6rem] flex w-full flex-col justify-center  overflow-hidden rounded-brand bg-[#EDEDED] px-[1rem] py-[4rem] md:py-[10rem] ">
      <h3 className="mb-[4rem] flex w-full justify-center text-center text-[3.2rem] font-semibold md:mb-[6.4rem] ">
        Trusted by over 200,000+ sellers
      </h3>
      <div className="no-scrollbar relative mx-auto flex w-full flex-col lg:w-[144rem]">
        <Reviews />
      </div>
    </div>
  );
};

export default SellerReviews;
